import "./App.css";
import { RouterProvider } from "react-router-dom";
import AppRouting from "./AppRouting";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./utils/axiosInterceptors";
import Loading from "./views/Loading";
import React from 'react';


const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // default: true
    },
  },
});

function App() {
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <Loading />
        <RouterProvider router={AppRouting} />
        <ToastContainer
          position="bottom-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        
      </QueryClientProvider>
    </>
  );
}

export default App;
